export enum RatingEnum {
  Excellent = 5,
  Good = 4,
  Neutral =3,
  Poor = 2,
  Bad = 1
}
